jQuery(document).ready(function() {

    if(jQuery('body').hasClass('home')) {
        jQuery(window).scroll(function () {

            var scrollTop = jQuery(window).scrollTop();

            if (scrollTop >= 100) {
                jQuery('#main-nav').removeClass('bg-transparent');
                jQuery('#main-nav').addClass('bg-light');
            } else {
                jQuery('#main-nav').removeClass('bg-light');
                jQuery('#main-nav').addClass('bg-transparent');
            }
        });

        jQuery('.navbar-toggler').on('click', function() {
            if(!jQuery(this).hasClass('collapsed')) {
                jQuery('#main-nav').removeClass('bg-transparent').addClass('bg-light');
            } else {
                jQuery('#main-nav').removeClass('bg-light').addClass('bg-transparent');

            }
        });
    }

    /*
     * simulateur aides
     */
    // get communes from gouv datas
    var departements = ["08", "10", "51", "52", "54", "55", "57", "67", "68", "88"];
    var communes_datas = [];

    jQuery.each(departements, function(index, value) {
        jQuery.ajax({
            url: "https://geo.api.gouv.fr/departements/" + value + "/communes",
            type: "get",
            autocomplete: 1,
            async: false,
            success: function (communes) {
                jQuery.each(communes, function(index, commune) {
                    var item = {
                        id: commune.code,
                        text: commune.nom + ' (' + commune.codesPostaux[0] + ')',
                    };
                    communes_datas.push(item);
                })
            }
        });
    });
    // alert(JSON.stringify(communes_datas));

    // put datas in "communes" field
    let input = jQuery('#estimation_popup.wpe_bootstraped[data-form="9"] .form-control[data-itemid="646"]');
    input.select2({
        data: communes_datas,
    });
});